import { cloneDeep } from 'lodash'

import { fetchDelete } from '@/utils/api'
import { getImgList } from '@/utils/common'

export const operationCreate = {
  label: '新增',
  name: 'create',
  tooltip: true,
  placement: 'left',
  icon: 'plus',
  func: operationEventCreate
}

export const operationUpdate = {
  label: '编辑',
  name: 'update',
  icon: 'edit',
  tooltip: true,
  func: operationEventUpdate
}

export const operationDelete = {
  label: '删除',
  name: 'delete',
  icon: 'delete',
  tooltip: true,
  func: operationEventDelete
}

export const operationSeePics = {
  label: '查看图片',
  name: 'seePic',
  icon: 'image',
  tooltip: true,
  func: operationEventSeePics
}

export const operationImages = {
  label: '查看图片',
  name: 'images',
  icon: 'image',
  tooltip: true,
  func: operationEventImages
}

export function operationEventCreate ({funcProps}) {
  const { table, data } = funcProps
  // const { labelName } = table
  const labelName = table.labelName ? '【' + data[table.labelName] + '】' : ''
  table.dialogLabel = '新增' + labelName + '子' + table.label
  if (table.label === '区域') {
    this.$confirm('如果此区域有包含数据，我们会全部清空, 是否继续?', '警告', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      table.dialogFormValues = cloneDeep(table.createFormValues)
      table.dialogFormValues[table.pid] = data[table.cid]
      table.dialogFormList = table.createList
      table.dialogButtonList = table.createButtonList
      table.dialogVisible = true
    }).catch(() => {
      this.$message.error('已关闭')
    })
  }
}

export function operationEventUpdate ({funcProps}) {
  const { table, data } = funcProps
  const labelName = table.labelName ? '【' + data[table.labelName] + '】' : ''
  // const deepData = cloneDeep(data)
  table.dialogLabel = '编辑' + table.label + labelName
  // console.info('table:', table)
  table.dialogFormValues = cloneDeep(data)
  // table.dialogFormValues = {
  //   id: deepData.id
  // }
  // table.updateList.map(item => {
  //   if (deepData[item]) table.dialogFormValues[item] = deepData[item]
  // })
  table.dialogFormList = table.updateList
  table.dialogButtonList = table.updateButtonList
  table.dialogVisible = true
}

export function operationEventDelete ({funcProps}) {
  const { table, data } = funcProps
  const labelName = table.labelName ? '【' + data[table.labelName] + '】' : ''
  table.$swal({
    title: '确认删除',
    text: '删除' + table.label + labelName + ', 是否继续?',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: '删除',
    cancelButtonText: '取消'
  }).then(res => {
    if (res) {
      fetchDelete({
        resource: table.resource,
        id: data.id
      }).then(data => {
        if (data) {
          table.getData()
          table.$swal('刪除成功', '', 'success')
        }
      })
    }
  }).catch(() => {})
}

export function operationEventSeePics ({funcProps}) {

}

export function operationEventImages ({funcProps}) {
  const { table, data } = funcProps
  table.lightImgs = getImgList(data.resFiles)
  table.$refs.lightbox.showImage(0)
}




// WEBPACK FOOTER //
// ./src/containers/DataTablePage/operation.js